import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteContact } from '../../api/apiContacts';
import toast from 'react-hot-toast';

export const useDeleteContact = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteContact,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['contacts'] });
            toast.success(data.message || 'Message deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to delete message';
            toast.error(errorMessage);
        },
    });
};